<template>
  <div class="box-input-money">
    <input
      type="text"
      ref="input"
      name="money"
      class="form-control text-right"
      v-currency="{currency: null, locale: 'ja', precision: 0, distractionFree: false, allowNegative: allowNegative}"
      v-model="displayValue"
      v-validate="validation"
      :data-vv-as="label"
      @blur="handleBlur"
      @focus="handleFocus"
      @input="handleInput"
    >
    <span style="display: block" v-show="errors.has('money') && inputDirty" class="text-danger">※{{ errors.first('money') }}</span>
  </div>
</template>
<script>
import { getValue } from 'vue-currency-input'
export default {
  props: {
    value: {
      type: Number
    },
    validation: {
      type: String
    },
    label: {
      type: String
    },
    currentRowData: {
      type: Object
    },
    allowNegative: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      isInputActive: false,
      isValidated: false,
      displayValue: this.value,
      isFocus: false
    }
  },
  computed: {
    inputDirty () {
      return this.fields.money.dirty || this.isValidated
    }
  },
  methods: {
    validateAll () {
      this.isValidated = true
      this.$validator.validateAll()
    },
    handleInput () {
      if (parseInt(this.displayValue.replace(',', '')) !== this.value || this.isFocus) {
        this.$emit('input', {
          currentRowData: this.currentRowData,
          newMoney: getValue(this.$refs.input)
        })
      }
    },
    handleFocus () {
      this.isInputActive = true
      this.isFocus = true
    },
    handleBlur () {
      this.isInputActive = false
      this.isFocus = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/InputMoney.vue